import styles from "./InputField.module.scss";
import { fetchPostcode } from "../../utils/searchAddress";

const PostcodeTextField = ({
  type = "text",
  name,
  label,
  register,
  validation = {},
  errors,
  setValue,
  prefField = "pref",
  addressField = "address",
  required = false,
  placeholder = "",
  isStatic = false,
  readOnly = false,
}) => {
  // 郵便番号から住所自動入力
  const searchAddress = async (e) => {
    const result = await fetchPostcode(e.target.value);

    if (typeof result !== "undefined" && result) {
      setValue(prefField, result.prefecture);
      setValue(addressField, result.city + result.suburb);
    }
  };

  return (
    <div className={styles.field} hidden={type === "hidden"}>
      <label className={`form-label ${styles.field__label}`}>
        {label}
        <span className={styles.field__label__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </label>

      <input
        className={`${styles.field__input} ${
          errors[name] ? "is-invalid" : ""
        } ${isStatic ? "form-control-plaintext" : "form-control"}`}
        type={type}
        placeholder={isStatic ? "" : placeholder}
        {...register(name, {
          ...validation,
          onChange: (e) => searchAddress(e),
        })}
        readOnly={isStatic || readOnly}
      />
      <p className={`invalid-feedback ${styles.field__msg}`}>
        {errors[name] ? errors[name].message : ""}
      </p>
    </div>
  );
};

export default PostcodeTextField;
